// SummaryCards.tsx

import { Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import type { FirmaAdendumTramitesResponse } from "../../types";

interface SummaryCardsProps {
  data: FirmaAdendumTramitesResponse;
}

export const SummaryCards = ({ data }: SummaryCardsProps) => {
  const count = Array.isArray(data?.data)
    ? data.data!.length.toLocaleString()
    : "—";

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4}>
        <SummaryCard
          icon={<DescriptionOutlinedIcon color="primary" />}
          label="Trámites"
          value={count}
        />
      </Grid>
    </Grid>
  );
};

interface SummaryCardProps {
  icon: React.ReactNode;
  label: string;
  value: string;
}

const SummaryCard = ({ icon, label, value }: SummaryCardProps) => {
  return (
    <Card sx={{ borderRadius: 3, boxShadow: 3, height: "100%" }}>
      <CardContent>
        <Stack spacing={1}>
          {icon}
          <Typography variant="h5" fontWeight={700}>
            {value}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {label}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default SummaryCards;
